<template>
  <div class="mt-16" v-for="review in getReviews" :key="review.id">
    <SingleReviewShort
      :reviewName="review.uf_name"
      :reviewDate="review.date"
      :reviewText="review.uf_comment"
      :reviewRating="review.uf_rating"
      :reviewPictures="review.picture_list"
      :reviewAnswer="review.uf_answer"
    >
    </SingleReviewShort>
  </div>

  <div class="grid-row d-flex_sm-wrap grid-row_md mt-16 d-flex_between">
    <div class="grid-col grid-col_sm-100 pt-8">
      <div v-if="isAuth">
        <PopupLeaveReview />
      </div>
    </div>
    <div
      class="grid-col grid-col_sm-100 pt-8"
      v-if="this.countMore < getReviewsCount"
    >
      <div
        class="btn btn_lg btn_stroke-dark-soft btn_px-lg border-radius-md w-100"
        type="button"
        @click="
          () => {
            countMore += 5;
          }
        "
      >
        Показать еще
      </div>
    </div>
  </div>
</template>

<script>
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import SingleReviewShort from "../SingleReview/SingleReviewShort.vue";
import PopupLeaveReview from "../Popups/PopupLeaveReview.vue";
import { useReviewsStore } from "@/pages/product_card/stores/store_reviews";

import * as Fancy from "@fancyapps/ui";
import { mapState } from "pinia";
const { Fancybox } = Fancy;

export default {
  name: "SliderReviews",
  components: {
    SingleReviewShort,
    PopupLeaveReview,
  },
  data() {
    return {
      isAuth: window.isAuth,
      countMore: 5,
    };
  },
  setup() {
    const storeReviews = useReviewsStore();

    return {
      storeReviews,
    };
  },
  computed: {
    ...mapState(useReviewsStore, ["getReviewsForSlider", "getReviewsCount"]),
    getReviews() {
      return this.getReviewsForSlider.slice(0, this.countMore);
    },
  },
  mounted() {
    Fancybox.bind("[data-fancybox=gallery-review]", {
      groupAll: true,
    });
    //document.documentElement.style.setProperty("--fancybox-zIndex", "2550");
  },
  updated() {
    Fancybox.unbind("[data-fancybox=gallery-review]");
    Fancybox.close();

    Fancybox.bind(
      "[data-fancybox=gallery-review]",
      "[data-fancybox=gallery-review]",
      {
        groupAll: true,
      }
    );
  },
  unmounted() {
    Fancybox.destroy();
  },
};
</script>
